define('views/modals/claim/content',['require','jquery','underscore','views/base/view','helpers/claim','text!templates/modals/claim/content-edit.ejs','text!templates/modals/claim/content-view.ejs','text!templates/modals/claim/content-loading.ejs','views/modals/claim/goods-collection','views/modals/claim/file-collection','views/modals/claim/doc-collection','views/modals/select-deal/index','models/modals/select-deal/index','views/demo-dialog'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        View = require('views/base/view'),
        claimHelper = require('helpers/claim'),
        templateEdit = require('text!templates/modals/claim/content-edit.ejs'),
        templateView = require('text!templates/modals/claim/content-view.ejs'),
        templateLoading = require('text!templates/modals/claim/content-loading.ejs'),
        ClaimGoodsCollectionView = require('views/modals/claim/goods-collection'),
        ClaimFileCollectionView = require('views/modals/claim/file-collection'),
        ClaimDocCollectionView = require('views/modals/claim/doc-collection'),
        SelectDealModalView = require('views/modals/select-deal/index'),
        SelectDealModalModel = require('models/modals/select-deal/index'),
        DemoDialog = require('views/demo-dialog');

    // require('select2');

    var ContentEditView = View.extend({
        autoRender: true,
        regions: {
            'claim-goods': '#claim-goods-container',
            'claim-files': '#claim-files-container'
        },
        template: templateEdit,
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', '.claim-content-row-goods .btn-toolbar .btn', this.onClickAddGoodsBtn);
            this.delegate('click', '.file-upload-area button', this.onClickAddFileBtn);
            this.delegate('change', '.file-upload-area input', this.onFileSelectChange);

            this._onChangeType = _.bind(this.onChangeType, this);
            this._onChangeCurrency = _.bind(this.onChangeCurrency, this);
            this._onChangeCost = _.bind(this.onChangeCost, this);
            this._onChangeDescription = _.bind(this.onChangeDescription, this);

            this._onInputSumKeypress = _.bind(this.onInputSumKeypress, this);
        },
        getTemplateData: function() {
            return _.defaults(View.prototype.getTemplateData.apply(this, arguments), claimHelper);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            var $sel = this.$('select');

            $sel.select2({
                minimumResultsForSearch: -1
            });

            var $type = this.$('.claim-content-row-type select');
            $type.off('change', this._onChangeType).on('change', this._onChangeType);
            $type.val(this.model.get('type')).trigger('change');

            var $currency = this.$('.claim-content-row-sum select');
            $currency.off('change', this._onChangeCurrency).on('change', this._onChangeCurrency);
            $currency.val(this.model.get('currencyId')).trigger('change');

            var $cost = this.$('.claim-content-row-sum input');
            $cost.off('change', this._onChangeCost).on('change', this._onChangeCost);
            $cost.off('keypress', this._onInputSumKeypress).on('keypress', this._onInputSumKeypress);

            var $description = this.$('.claim-content-row-description textarea');
            $description.off('change', this._onChangeDescription).on('change', this._onChangeDescription);

            this.subview('content-goods', new ClaimGoodsCollectionView({ model: this.model, collection: this.model.goods }));
            this.subview('content-files', new ClaimFileCollectionView({ model: this.model, collection: this.model.files }));
        },
        onChangeType: function(ev) {
            var value = $(ev.target).val();
            this.model.set('type', value);
        },
        onChangeCurrency: function(ev) {
            var value = $(ev.target).val();
            this.model.set('currencyId', value);
        },
        onChangeCost: function(ev) {
            var value = parseFloat($(ev.target).val());
            $(ev.target).val(value);
            this.model.set('cost', value);
        },
        onChangeDescription: function(ev) {
            var value = $(ev.target).val();
            this.model.set('description', value);
        },
        onInputSumKeypress: function(ev) {
            var key = ev.charCode;

            if (key === 44) { // ,
                key = 46;  // .
            }

            var valid = (key >= 48 && key <= 57 || key === 46);
            if  (!valid) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        },
        onClickAddGoodsBtn: function() {
            var model = this.model;

            var modalModel = new SelectDealModalModel({});
            modalModel.on('action', function(action, cancel) {
                if (action === 'submit') {

                    var selected = modalModel.content.getSelected();
                    if (selected && selected.length) {
                        selected = _.map(selected, function(item) {
                            return {
                                id: null,
                                dealId: item.id,
                                fullName: item.fullName,
                                canEdit: true
                            };
                        });
                        model.goods.add(selected);
                    } else {
                        cancel();
                    }
                }
            });

            this.subview('card', new SelectDealModalView({ model: modalModel }));

            modalModel.content.set('tradeId', this.model.get('tradeId'));
            modalModel.content.load();
        },
        onClickAddFileBtn: function() {
            if (DemoDialog.isDemo()) { return DemoDialog.show(); }

            this.$('.file-upload-area input').click();
        },
        onFileSelectChange: function(ev) {
            var files = ev.target.files;
            for (var i=0, li=files.length; i<li; i++) {
                this.model.files.add({
                    file: files[i],
                    claimId: this.model.get('claimId')
                });
            }
        }
    });

    var ContentViewView = View.extend({
        autoRender: true,
        regions: {
            'claim-goods': '#claim-goods-container',
            'claim-files': '#claim-files-container',
            'claim-docs': '#claim-docs-container'
        },
        template: templateView,
        getTemplateData: function() {
            return _.defaults(View.prototype.getTemplateData.apply(this, arguments), claimHelper);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            if (this.model.goods.length) {
                this.subview('content-goods', new ClaimGoodsCollectionView({ model: this.model, collection: this.model.goods }));
            }

            if (this.model.files.length) {
                this.subview('content-files', new ClaimFileCollectionView({ model: this.model, collection: this.model.files }));
            }

            if (this.model.docs.length) {
                this.subview('content-docs', new ClaimDocCollectionView({ model: this.model, collection: this.model.docs }));
            }
        }
    });

    var ContentLoadingView = View.extend({
        autoRender: true,
        className: 'loading',
        template: templateLoading
    });

    var ClaimModalContentView = View.extend({
        autoRender: true,
        className: 'claim-modal-content',
        region: 'modal-content',
        listen: {
            'afterLoad model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            if (this.model.get('loaded')) {
                if (this.model.get('canEdit')) {
                    this.subview('content', new ContentEditView({ model: this.model, container: this.el }));
                } else {
                    this.subview('content', new ContentViewView({ model: this.model, container: this.el }));
                }
            } else {
                this.subview('content', new ContentLoadingView({ model: this.model, container: this.el }));
            }
        },
        afterLoad: function() {
            this.render();
        }
    });

    return ClaimModalContentView;
});

